import { Component, OnInit } from "@angular/core";
import { DataService } from '../../shared/dataService';
import { JobOffer } from '../../shared/joboffer';

@Component({
    selector: "job-offers-display",
    templateUrl: "jobofferspage.component.html",
    styleUrls: []
})

export class JobOffersPage implements OnInit {
    constructor(private data: DataService) {
    }

    public jobOffers: JobOffer[] = [];

    ngOnInit(): void {
        this.data.loadJobOffers().subscribe(success => {
            if (success) {
                this.jobOffers = this.data.jobOffers;
            }
        });
    }
}